import { render, staticRenderFns } from "./accessrule.vue?vue&type=template&id=21179280&"
import script from "./accessrule.vue?vue&type=script&lang=js&"
export * from "./accessrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports